import React, {useEffect, useState} from 'react';
import '../CSS/style/style.css';
import PopupModal from "./PopupModal";

const Main = () => {

    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const isMobile = window.innerWidth <= 480;

        console.log("isMobile", isMobile);
        if (!isMobile) {
            setShowPopup(true);
        }
    }, []);

    return (
        <div className="main-wrapper">
            {showPopup && <PopupModal onClose={() => setShowPopup(false)} />}
            <section className="main-banner"></section>

            <div className="main-container">
                <h2>INFORMATION</h2>
                <p>
                    자연 속에서 쉬어가는 따뜻한 공간, 물조은 펜션.<br/>
                    가족, 친구, 연인과 함께 머물기 좋은 아늑한 쉼터.<br/>
                    언제 찾아도 편안하고 정겨운 당신만의 힐링 플레이스.<br/>
                </p>

                <hr style={{border: 'none', borderTop: '1px solid #ddd', margin: "150px 0"}}/>

                <h2>INTRODUCE</h2>
                <div style={{position: 'relative', width: '100%', maxWidth: '100%', aspectRatio: '16/9'}}>
                    <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/vx7NGekiatI?autoplay=1&mute=1&rel=0&showinfo=0"
                        title="물조은펜션 소개영상"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                        style={{border: 'none', borderRadius: '12px'}}
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default Main;
